var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef } from 'react';
import { Row, Col } from 'antd';
import Sticky from 'react-stikky';
import cls from 'classnames';
import styled from 'styled-components';
import { useDeepFormItem } from '../context';
import { createVirtualBox } from '@formily/react-schema-renderer';
var getAlign = function (align) {
    if (align === 'start' || align === 'end')
        return align;
    if (align === 'left' || align === 'top')
        return 'flex-start';
    if (align === 'right' || align === 'bottom')
        return 'flex-end';
    return align;
};
var isElementInViewport = function (rect, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.offset, offset = _c === void 0 ? 0 : _c, _d = _b.threshold, threshold = _d === void 0 ? 0 : _d;
    var top = rect.top, right = rect.right, bottom = rect.bottom, left = rect.left, width = rect.width, height = rect.height;
    var intersection = {
        t: bottom,
        r: window.innerWidth - left,
        b: window.innerHeight - top,
        l: right
    };
    var elementThreshold = {
        x: threshold * width,
        y: threshold * height
    };
    return (intersection.t >=
        (offset.top || offset + elementThreshold.y) &&
        intersection.r >=
            (offset.right || offset + elementThreshold.x) &&
        intersection.b >=
            (offset.bottom || offset + elementThreshold.y) &&
        intersection.l >=
            (offset.left || offset + elementThreshold.x));
};
export var FormButtonGroup = styled(function (props) {
    var span = props.span, zIndex = props.zIndex, sticky = props.sticky, style = props.style, offset = props.offset, className = props.className, children = props.children, triggerDistance = props.triggerDistance, itemStyle = props.itemStyle;
    var inline = useDeepFormItem().inline;
    var selfRef = useRef();
    var renderChildren = function () {
        return (React.createElement("div", { className: "button-group" },
            React.createElement(Row, null,
                React.createElement(Col, { span: span, offset: offset, className: "inline" },
                    React.createElement("div", { className: "inline-view", style: itemStyle }, children)))));
    };
    var getStickyBoundaryHandler = function () {
        return function () {
            if (selfRef.current && selfRef.current.parentElement) {
                var container = selfRef.current.parentElement;
                return isElementInViewport(container.getBoundingClientRect());
            }
            return true;
        };
    };
    var content = (React.createElement("div", { className: cls(className, {
            'is-inline': !!inline
        }), style: style }, renderChildren()));
    if (sticky) {
        return (React.createElement("div", { ref: selfRef },
            React.createElement(Sticky, { edge: "bottom", triggerDistance: triggerDistance, zIndex: zIndex, getStickyBoundary: getStickyBoundaryHandler(), style: {
                    borderTop: '1px solid #eee',
                    background: (style && style.background) || '#fff',
                    padding: (style && style.padding) || '8px 0'
                } },
                React.createElement("div", { className: className, style: style }, content))));
    }
    return content;
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  &.is-inline {\n    display: inline-block;\n    flex-grow: 3;\n  }\n  .button-group {\n    .inline {\n      display: inline-block;\n      .inline-view {\n        & > * {\n          margin-right: 10px;\n          margin-left: 0px;\n          display: inline-block;\n        }\n        & > *:last-child {\n          margin-right: 0 !important;\n        }\n      }\n    }\n  }\n"], ["\n  ",
    "\n  &.is-inline {\n    display: inline-block;\n    flex-grow: 3;\n  }\n  .button-group {\n    .inline {\n      display: inline-block;\n      .inline-view {\n        & > * {\n          margin-right: 10px;\n          margin-left: 0px;\n          display: inline-block;\n        }\n        & > *:last-child {\n          margin-right: 0 !important;\n        }\n      }\n    }\n  }\n"])), function (props) {
    return props.align ? "display:flex;justify-content: " + getAlign(props.align) : '';
});
createVirtualBox('button-group', FormButtonGroup);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/components/FormButtonGroup.js
// module id = 5793
// module chunks = 0